export const ProfileLoading = 'ProfileLoading'
export const ResetState = 'ResetState'
export const SetAccountRecoverLoginId = 'SetAccountRecoverLoginId'
export const SetAccountRecoverCredentialsId = 'SetAccountRecoverCredentialsId'
export const SetAuthFlowPayload = 'SetAuthFlowPayload'
export const SetAuthFlowWithProvider = 'SetAuthFlowWithProvider'
export const SetAuthToken = 'SetAuthToken'
export const SetAuthReady = 'SetAuthReady'
export const SetCurrentCredentials = 'SetCurrentCredentials'
export const SetCurrentSessionId = 'SetCurrentSessionId'
export const SetRefreshToken = 'SetRefreshToken'
export const SetRefreshDeadline = 'SetRefreshDeadline'
export const SetSessions = 'SetSessions'
export const SetUserId = 'SetUserId'
export const UpdateCredentials = 'UpdateCredentials'
export const UpdateProfiles = 'UpdateProfiles'
export const PendingAccountConfirmation = 'PendingAccountConfirmation'
export const UpdateSessions = 'UpdateSessions'
